import React from 'react';
import {Button, Modal, Select} from "antd";

const ExportModal = (props) => {
    return (
        <Modal title="Picture Export
"
               open={props.isModalOffice}
               onCancel={() => props.setIsModalOffice(false)}
        >
            <div className="cam-add-modal">

                <h6 className="text-white">
                    Picture type
                </h6>
                <div className="mt-2">
                    <input type="checkbox"/>
                    <label className="font-family-medium ml-8">Face image</label>
                </div>
                <div className="mt-2">
                <input type="checkbox"/>
                    <label className="font-family-medium ml-8">Humanoid image</label>
                </div>
                <div className="mt-2">
                <input type="checkbox"/>
                    <label className="font-family-medium ml-8">Background image</label>
                </div>
                <div className="mt-3">
                    <label className="font-family-medium mr-24">Start Time</label>
                    <input type="datetime-local"/>
                </div>
                <div className="mt-3">
                    <label className="font-family-medium mr-24">End Time</label>
                    <input type="datetime-local" className="ml-8"/>
                </div>
                <div className="col-6 mt-3">
                    <button className="btn btn-outline-light w-100">Search</button>
                </div>
                <h6 className="text-white mt-3">File List</h6>

                <div className="mt-2">
                    <input type="checkbox"/>
                    <label className="font-family-medium ml-8">File name</label>
                </div>
                <div className="mt-3 mb-2">
                    <label className="font-family-medium mr-24 mb-2">Capture <span className="ml-24">Total 0</span></label>
                    <Select

                        placeholder="Поиск, чтобы выбрать"
                        optionFilterProp="children"
                        className="w-100"

                    >
                        <option value="1">asd</option>
                        <option value="3">asd</option>
                        <option value="2">asd</option>
                    </Select>
                    <div className="  mt-3">
                        <button className="btn btn-outline-light w-100">Export selected</button>
                    </div>
                </div>
            </div>

        </Modal>
    );
};

export default ExportModal;